import {Button, Stack} from '@mui/material';
import React from 'react';
import {Navigate, useLocation, useNavigate} from 'react-router-dom';

import {SelectionUserPlanEnum} from 'main/analytics/gaTagsEnum';
import {StyledGrid} from 'presentation/components';
import {Loading} from 'presentation/components/Loading/Loading';
import {SelectionFlowEnum} from 'presentation/constants';
import Icon from 'presentation/icons';
import {useMediaQueries} from 'presentation/pages/private';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {PlanCard} from '../../components/PlanCard';
import {useSelection} from '../../hooks/useSelection';
import {useSelectedBeneficiaryStore} from '../../store/useSelectedBeneficiaryStore';
import {useSelectedPlanStore} from '../../store/useSelectedPlanStore';
import {ConfirmationFooter} from './styles';

const {confirm, change} = translations['pt-br'].commons;

export function ConfirmSelection() {
	const {isTablet} = useMediaQueries();

	const selectedBeneficiary = useSelectedBeneficiaryStore(state => state.selectedBeneficiary);
	const resetSelectedBeneficiary = useSelectedBeneficiaryStore(
		state => state.resetSelectedBeneficiary,
	);
	const {confirmSelection, isSubmitting} = useSelection();
	const selectedPlan = useSelectedPlanStore(state => state.selectedPlan);
	const navigate = useNavigate();
	const {state} = useLocation();

	const handleGoToPlans = () => {
		resetSelectedBeneficiary();
		navigate(SelectionFlowEnum.PLAN_SELECTION, {state});
	};

	if (selectedBeneficiary?.nuContrato !== selectedPlan?.nuContrato) {
		return <Navigate to={SelectionFlowEnum.BENEFICIARY_SELECTION} replace />;
	}

	return (
		<StyledGrid.Root padding={isTablet ? 2 : 4} spacing={3} flex={1}>
			<StyledGrid.Item sm={12} md={8} lg={6} xl={4}>
				<Stack gap={2}>
					{selectedPlan ? (
						<PlanCard
							beneficiaryName={formatText(
								selectedBeneficiary?.nmSocialUsuarioC ??
									selectedBeneficiary?.nmUsuarioC,
							)}
							plan={selectedPlan}
							actionButton={
								<Button onClick={handleGoToPlans} variant="text">
									{change}
								</Button>
							}
						/>
					) : null}
					<ConfirmationFooter>
						<Button
							data-tag-id={SelectionUserPlanEnum.CONFIRMOU_USUARIO_E_CIDADE}
							onClick={() => confirmSelection({})}
							disabled={isSubmitting}
							variant="contained"
							size="large"
							fullWidth
							endIcon={
								isSubmitting ? (
									<Loading size={16} color="inherit" />
								) : (
									<Icon name="success" />
								)
							}>
							{confirm}
						</Button>
					</ConfirmationFooter>
				</Stack>
			</StyledGrid.Item>
		</StyledGrid.Root>
	);
}
